import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const EmbedIcon = createIcon({
  displayName: 'EmbedIcon',
  path: [
    <path
      d='M15 9L18.5 12.25L15 15.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M9.5 9L6 12.25L9.5 15.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
